import useSWR from 'swr';

import { ILoyalty } from 'containers/Loyalty/api';
import { IDetailResponse, IPaginatedResponse } from 'utils/types';

import { buildQuery, fetcher } from './utils';

export const useLoyaltyProgram = (id: number) => {
  const { data, isLoading, isValidating, error, mutate } = useSWR<IDetailResponse<ILoyalty>>(
    id ? `/v4/dash/loyalty_programs/${id}` : null,
    fetcher
  );

  return { data: data?.data, isLoading, isValidating, error, mutate };
};

export const useLoyaltyProgramList = (params?: object) => {
  const { data, isLoading, isValidating, error, mutate } = useSWR<IPaginatedResponse<ILoyalty>>(
    `/v4/dash/loyalty_programs?${buildQuery(params)}`,
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, isValidating, error, mutate };
};
